/**
 * tRPC React-Client. Importiert nur den `AppRouter`-Type aus `@hirebotiq-ops/api`,
 * keine Runtime-Dependencies — type-only Import wird vom Bundler aus dem
 * Bundle entfernt.
 */
import type { AppRouter } from '@hirebotiq-ops/api/trpc';
import { createTRPCReact } from '@trpc/react-query';

export const trpc = createTRPCReact<AppRouter>();
